import React from 'react';
import "../Main-Footer/mfooter.css";
import companyLogo from "../../Assets/LOGO1.png";

function MFooter() {
    return (
        <>
            {/* ===== FOOTER ===== */}
            < footer className="sb-footer" >
                <div className="container">
                    <div className="row align-items-center gy-3 gx-4">
                        <div className="col-auto">
                            <div className="d-flex align-items-center gap-2">
                                <img
                                    src={companyLogo}
                                    alt="Sound Barrier"
                                    className="sidebar-logo"
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="d-flex flex-wrap gap-4">
                                {[
                                    { icon: "fa fa-clock-o", label: "On-time\nDelivery" },
                                    { icon: "fa fa-wrench", label: "Technical\nExpertise" },
                                    { icon: "fa fa-globe", label: "Pan India & GCC\nPresence" },
                                ].map((f) => (
                                    <div className="footer-item" key={f.label}>
                                        <i className={f.icon}></i>
                                        <div className="footer-item-label" style={{ whiteSpace: "pre-line" }}>{f.label}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-auto footer-contact text-end">
                            <div className="d-flex flex-column gap-1 align-items-end">
                                <a href="tel:+918041624500" className="d-flex align-items-center gap-1">
                                    <i className="fa fa-phone" style={{ color: "var(--sb-orange)" }}></i>
                                    +91 80 4162 4500
                                </a>
                                <a href="mailto:enquiry@acousticalsurfaces.in" className="d-flex align-items-center gap-1">
                                    <i className="fa fa-envelope" style={{ color: "var(--sb-orange)" }}></i>
                                    enquiry@acousticalsurfaces.in
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer >
        </>
    )
}

export default MFooter